import { Point2D } from "types/geometry";

type RosPathLike = {
    poses?: Array<{
        pose?: {
            position?: { x?: number; y?: number };
        };
    }>;
};

/** Parse `nav_msgs/Path` from rosbridge into map-frame 2D points. */
export function parseNavPathMessage(pathMsg: unknown): Point2D[] {
    const msg = pathMsg as RosPathLike;
    if (!Array.isArray(msg?.poses)) {
        return [];
    }

    const points: Point2D[] = [];
    for (const poseStamped of msg.poses) {
        const pos = poseStamped?.pose?.position;
        if (
            typeof pos?.x !== "number" ||
            !Number.isFinite(pos.x) ||
            typeof pos?.y !== "number" ||
            !Number.isFinite(pos.y)
        ) {
            continue;
        }
        points.push({ x: pos.x, y: pos.y });
    }
    return points;
}
